import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { asyncScheduler, EMPTY as empty, Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { Logout} from '../actions/auth.actions';
import { UserService } from '../../../user/user.service';

@Injectable()
export class AuthEffects {


  constructor(
    private actions$: Actions,
    private userService: UserService,
    private router: Router
  ) {}
}
